import * as React from "react";
import { SVGProps } from "react";

const OutflowIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.6 20.05H19.2C19.5556 20.05 19.85 19.7557 19.85 19.4C19.85 19.0444 19.5556 18.75 19.2 18.75H5.6C5.24439 18.75 4.95 19.0444 4.95 19.4C4.95 19.7557 5.24439 20.05 5.6 20.05Z"
      fill="#DA291C"
      stroke="#DA291C"
      strokeWidth="0.1"
    />
    <path
      d="M17.5405 16.2593C17.6704 16.3892 17.8354 16.45 17.9999 16.45C18.1644 16.45 18.3294 16.3892 18.4593 16.2593C18.7108 16.0078 18.7108 15.5921 18.4593 15.3406L7.25926 4.1406C7.00773 3.88907 6.59208 3.88907 6.34055 4.1406C6.08902 4.39212 6.08902 4.80778 6.34055 5.05931L17.5405 16.2593Z"
      fill="#DA291C"
      stroke="#DA291C"
      strokeWidth="0.1"
    />
    <path
      d="M6.14995 12.816C6.14995 13.1716 6.44434 13.466 6.79995 13.466C7.15557 13.466 7.44995 13.1716 7.44995 12.816V5.25H15.016C15.3716 5.25 15.666 4.95561 15.666 4.6C15.666 4.24439 15.3716 3.95 15.016 3.95H6.79995C6.44434 3.95 6.14995 4.24439 6.14995 4.6V12.816Z"
      fill="#DA291C"
      stroke="#DA291C"
      strokeWidth="0.1"
    />
  </svg>
);

export default OutflowIcon;
